import { render, staticRenderFns } from "./pay-record.vue?vue&type=template&id=322f84fa&scoped=true"
import script from "./pay-record.vue?vue&type=script&lang=ts"
export * from "./pay-record.vue?vue&type=script&lang=ts"
import style0 from "./pay-record.vue?vue&type=style&index=0&id=322f84fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322f84fa",
  null
  
)

export default component.exports